<template>
  <a-tree-select :value="defaultValue"
                 style="width: 100%"
                 v-bind="instance"
                 :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                 :tree-data="instance.list"
                 tree-default-expand-all
                 @select="onSelected">
    <a-icon slot="suffixIcon"
            type="search" />
  </a-tree-select>
</template>

<script>
export default {
  props: {
    instance: Object
  },
  data() {
    return {
      defaultValue: ''
    }
  },
  watch: {
    instance: {
      handler(nVal) {
        Object.assign(this, { ...nVal }) // 把传入的参数，融合到this中
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSelected(value, node, extra) {
      console.log(value, node, extra)
      this.$emit('change', value)
    }
  }
}
</script>

<style>
</style>